import { Image, List, Space } from 'antd'
import { useTranslation } from 'react-i18next'

const ItemsList = <T extends Item>({ items, renderCheckbox, renderComment }: ItemListProps<T>) => {
  const { t } = useTranslation()
  return (
    <List
      dataSource={items}
      style={{ maxWidth: '490px' }}
      renderItem={(item) => (
        <List.Item
          key={item.itemId}
          style={{
            display: 'flex',
            width: 'fit-content'
          }}
        >
          <Space size='small' direction='vertical' style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
            <Space
              direction='horizontal'
              size='middle'
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row'
              }}
            >
              {!!renderCheckbox && renderCheckbox(item)}
              <Image width={50} src={item.photoUrl} alt={item.name} />
              <div>
                <div>{item.name}</div>
                <div>
                  {item.foundQuantity} {item.presentationV2.unit} | {t('jobs.itemList.price')}:{' '}
                  {item.presentation.price.amount} {item.presentation.price.currencyCode}
                </div>
              </div>
            </Space>
            {!!renderComment && renderComment(item)}
          </Space>
        </List.Item>
      )}
    />
  )
}

export default ItemsList

type Item = {
  itemId: string
  name: string
  photoUrl: string
  foundQuantity: number
  presentationV2: {
    quantity: number
    price: number
    unit: string
  }
  presentation: {
    price: {
      amount: number
      currencyCode: string
    }
  }
}

type ItemListProps<T> = {
  items: T[]
  renderCheckbox?: (item: T) => JSX.Element | undefined
  renderComment?: (item: T) => JSX.Element | undefined
}
